export async function redirectToCheckout(items: any[], customerEmail?: string, orderNote?: string) {
  try {
    const response = await fetch('/api/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items, customerEmail, orderNote }),
    });

    const session = await response.json();

    if (session.error) {
      throw new Error(session.error);
    }

    if (session.url) {
      // Stripe Checkout cannot be loaded inside an iframe.
      // We try to redirect the top-level window first.
      try {
        if (window.top && window.top !== window) {
          window.top.location.href = session.url;
        } else {
          window.location.href = session.url;
        }
      } catch (e) {
        // If top-level redirect is blocked by cross-origin policy,
        // open in a new tab as a fallback.
        window.open(session.url, '_blank');
      }
    } else {
      throw new Error('No checkout URL received');
    }
  } catch (error) {
    console.error('Checkout Error:', error);
    throw error;
  }
}
